import { render, staticRenderFns } from "./ControlReason.vue?vue&type=template&id=10880d8e"
import script from "./ControlReason.vue?vue&type=script&lang=js"
export * from "./ControlReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports